import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from "mdbreact";
import { Link } from "react-router-dom";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import moment from "moment";
import Parser from "html-react-parser";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

class cutomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allDetails: [],
      isdeleted: false,
      searchInput: "",
      UserDetail: [],
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "rgb(216, 23, 100)",
    });
    var login = localStorage.getItem("LoginDetail");
        var details = JSON.parse(login);
        // console.log(details[0])
        this.setState({
          Usertype: details[0].fld_usertype,
        });
        console.log("this.state.Usertype  " + this.state.Usertype )
        if (details[0].fld_usertype != "Admin")
        {
          window.location.href = "/"
          }

    Notiflix.Loading.Dots("");

    GetApiCall.getRequest("Get_Userlist").then((resultdes) =>
      resultdes.json().then((obj) => {
        console.log(obj.data);

        this.setState({
          UserDetail: obj.data,
        });

        Notiflix.Loading.Remove();
      })
    );
  }

  viewdetail = (data) => {
    if (this.state.isdeleted === false) {
      return (
        localStorage.setItem("ClientDetails", [JSON.stringify(data)]),
        this.props.history.push("/edit_client")
      );
    } else if (this.state.isdeleted === true) {
      return (
        localStorage.setItem("ClientDetails", [JSON.stringify(data)]),
        this.props.history.push("/view-clients")
      );
    }
  };

  // fld_gender
  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value });
  };
  render() {
    const data = {
      columns: [
        {
          label: "S.No.",
          field: "serial",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Name",
          field: "name",
          sort: "disabled",
          width: 270,
        },
        {
          label: "Email",
          field: "email",
          sort: "disabled",
          width: 200,
        },
        {
          label: "Mobile",
          field: "mobile",
          sort: "disabled",
          width: 100,
        },

        {
          label: "User Type",
          field: "user",
          sort: "disabled",
          width: 100,
        },

        // {
        //     label: "Action",
        //     field: "action",
        //     sort: "disabled",
        //     width: 100
        // }
      ],
      rows: Array(...this.state.UserDetail)
        .filter((data) => {
          let name = data.fld_name && [
            ...data.fld_name
              .toLowerCase()
              .matchAll(this.state.searchInput.toLowerCase()),
          ];
          //    let mobno = [...data.fld_mobile.toLocaleLowerCase().matchAll(this.state.searchInput.toLocaleLowerCase())]
          let email = data.fld_email && [
            ...data.fld_email
              .toLowerCase()
              .matchAll(this.state.searchInput.toLocaleLowerCase()),
          ];

          if (this.state.searchInput.length > 0 && name[0]) {
            return data;
          }

          // if (this.state.searchInput.length > 0  && designaition[0]) {
          //   return data
          // }
          if (this.state.searchInput.length > 0 && email[0]) {
            return data;
          }

          if (this.state.searchInput.length == 0) {
            return data;
          }
        })
        .map((data, i) => {
          //  console.log(data)
          return {
            serial: <td>{i + 1}</td>,
            name: <td>{data.fld_name}</td>,
            mobile: <td>{data.fld_mobile}</td>,
            email: <td>{data.fld_email}</td>,
            user: <td>{data.fld_usertype}</td>,
            //     action: <td className='text-center actionuser'>
            //         <i className="fas fa-edit btn" style={{ fontSize: '15px', marginTop: '-11px' }}
            //             onClick={() => this.viewdetail(data)}>

            //         </i>
            //   </td>
          };
        }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={"User Management"}
              breadcrumbItem={"User List"}
            />
            <Row>
              <Col xl="12">
                <Card className="overflow-hidden">
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "rgb(171, 61, 0)" }}
                  >
                    <Row>
                      <Col xs="6">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text text-white">
                            User Management
                          </h5>
                        </div>
                      </Col>
                    </Row>
                    <Row></Row>
                  </div>

                  <Card className="overflow-hidden">
                    <div
                      className="maxXchange-bg-soft-pink"
                      style={{ background: "#dfb65c" }}
                    >
                      <Row>
                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                            <h5 className="maxXchange-text">User List</h5>
                          </div>
                        </Col>

                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                            <Link
                              to="/add_user"
                              style={{ float: "right", marginTop: "-5px" }}
                              className="btn align-items-center btn maxXchange-btn "
                            >
                              Add New User{" "}
                              <i className="fa fa-plus" aria-hidden="true"></i>
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-0">
                      <Row>
                        <MDBCol
                          md="3"
                          style={{ marginBottom: "10px", marginTop: "10px" }}
                        >
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={(e) => this.seachBarHandler(e)}
                            value={this.state.searchInput}
                          />
                        </MDBCol>
                        <Col md="12">
                          <MDBDataTableV5
                            striped
                            bordered
                            small
                            data={data}
                            searchBottom={false}
                            seachTop={true}
                          >
                            <MDBTableHead columns={data.columns} />
                            <MDBTableBody rows={data.rows} />
                          </MDBDataTableV5>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  {/* <WelcomeComp /> */}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default cutomerList;
